import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import { Theme, SxProps } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import TablePagination, { TablePaginationProps } from '@mui/material/TablePagination';

// ----------------------------------------------------------------------

type Props = {
  dense?: boolean;
  onChangeDense?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
};

export default function DataTablePagination({
  dense,
  onChangeDense,
  // rowsPerPageOptions = [5, 10, 25],
  rowsPerPageOptions = [15, 25, 50, 100],
  sx,
  ...other
}: Props & TablePaginationProps) {
  return (
    <Box sx={{ position: 'relative', display: 'flex', justifyContent:'space-between', alignItems:'center', ...sx }}>
      {/* Dense Toggle */}
      {onChangeDense && (
        <FormControlLabel
        label="Dense"
          control={<Switch id="dense-toggle" checked={dense} onChange={onChangeDense} />}
          sx={{
            pl: 2,
          }}
        />
      )}

      {/* Pagination Panel */}
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        {...other}
        sx={{
          borderTopColor: 'transparent',
        }}
      />
    </Box>
  );
}
